var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"margin-top":"30px"},attrs:{"width":"100%","src":_vm.$config.analyticUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }